import { render, staticRenderFns } from "./lottery-starfield.vue?vue&type=template&id=1414c4fd&scoped=true"
import script from "./lottery-starfield.vue?vue&type=script&lang=js"
export * from "./lottery-starfield.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1414c4fd",
  null
  
)

export default component.exports